/* eslint-disable react/no-danger */
import * as React from 'react';

import type { PromoTemplatePageData } from 'bundles/promo-template/queries/hooks/usePageContentQuery';
import { clearEmptyFields } from 'bundles/seo/utils/utils';

type Props = {
  data: PromoTemplatePageData;
};
const PromoTemplateWebPageSchemaMarkup = ({ data }: Props) => {
  const imageUrl =
    data.seoImageUrl || data.blocks.find((block) => block.__typename === 'PromoTemplateHero')?.image?.url;
  const markupJson = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: `${data.seoTitle} | Coursera`,
    description: data.seoDescription,
    image: imageUrl,
    url: data.seoCanonical,
  };

  const createMarkup = () => ({
    __html: `
      <script type="application/ld+json">
        ${JSON.stringify(clearEmptyFields(markupJson))}
      </script>
    `,
  });

  return (
    <div className="rc-PromoTemplateWebPageSchemaMarkup">
      <div dangerouslySetInnerHTML={createMarkup()} />
    </div>
  );
};

export default PromoTemplateWebPageSchemaMarkup;
